import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static values = {
    additionalInputClasses: String
  }

  connect() {
    this.element[this.identifier] = this

    this.editing = false
    this.modelName = this.data.get("name")
    this.modelClass = this.modelName.substring(0, this.modelName.indexOf("["))
    this.modelAttr = this.modelName.substring(this.modelName.indexOf("[") + 1, this.modelName.length - 1)
    this.formUrl = this.data.get("url")
    this.modelValue = this.data.get("value")
    this.originalElement = this.element
    this.input = this.inputElement()

    this.blurHandler = this.onBlur.bind(this)
    this.element.addEventListener("click", this.onClick.bind(this))
    this.input.addEventListener("keyup", this.onInput.bind(this))
    this.input.addEventListener("blur", this.blurHandler)
  }

  onClick(e) {
    this.replaceWithInputField()
    this.editing = true
  }

  onBlur(e) {
    if (this.input.value.trim() != this.originalElement.textContent.trim()) {
      this.onSave(e)
    } else {
      this.replaceInputWithOriginalElement()
    }
  }

  replaceWithInputField() {
    this.element.replaceWith(this.input)
    this.input.value = this.originalElement.textContent.trim()
    this.input.focus()
  }

  replaceInputWithOriginalElement() {
    this.input.replaceWith(this.originalElement)
  }

  inputElement() {
    let input = document.createElement('input')
    input.type = "text"
    input.name = this.modelName
    input.id = `${this.modelName.replace("[", "_").replace("]", "")}`
    input.classList.add("block", "shadow-sm", "focus:ring-green-500", "focus:border-green-500", "sm:text-sm", "border-gray-300", "rounded-md")
    if (this.hasAdditionalInputClassesValue && this.additionalInputClassesValue.trim() !== "") {
      input.classList.add(...this.additionalInputClassesValue.split(" "))
    }
    input.value = this.modelValue

    return input
  }

  async onSave(e) {
    let formData = {}
    formData[this.modelClass] = {}
    formData[this.modelClass][this.modelAttr] = this.input.value
    const request = new FetchRequest("PATCH", this.formUrl, { body: JSON.stringify(formData), responseKind: 'json' })
    const response = await request.perform()

    if (response.ok) {
      this.originalElement.innerHTML = this.input.value
      this.replaceInputWithOriginalElement()
      this.input.addEventListener("blur", this.blurHandler)
    } else {
      alert("There was an error saving this field! Let Mike know please")
    }
  }

  onInput(e) {
    if (e.keyCode == 13) {
      this.input.removeEventListener("blur", this.blurHandler)
      this.onSave(e)
    } else if (e.keyCode == 27) {
      this.input.removeEventListener("blur", this.blurHandler)
      this.reset()
    }
  }

  reset() {
    this.replaceInputWithOriginalElement()
    this.input.addEventListener("blur", this.blurHandler)
  }

}
